<mat-accordion displayMode="flat" togglePosition="before" class="mat-list-custom">
  <div class="sidecontent-option-container" [ngSwitch]="displayedContent">
    <div class="scroll-container">
      <!-- done -->
      <ng-container *ngSwitchCase="widgetTypes.plainText">
        <form [formGroup]="textGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel class="" expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Text Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Text</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="textGroup.get('label')?.value?.trim().length == 0">Enter value to
                  the label</mat-error>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ textGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="textGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
                <ng-container [ngTemplateOutlet]="fontIconTemplate"
                  [ngTemplateOutletContext]="{ formGroup: textGroup }"></ng-container>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.filePicker">
        <form [formGroup]="filePickerGroup">
          <mat-accordion displayMode="flat" togglePosition="before">
            <mat-form-field class="w-100 rounded-0 mat-no-hint">
              <mat-label>Key</mat-label>
              <input matInput type="text" formControlName="key" />
            </mat-form-field>
            <mat-divider></mat-divider>
            <mat-expansion-panel expanded="true">
              <mat-expansion-panel-header>
                <mat-panel-title> File Properties</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ps-4 mat-form-field-container">
                <mat-form-field appearance="outline">
                  <mat-label>Display Type</mat-label>
                  <mat-select formControlName="matUiType">
                    <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Label</mat-label>
                  <input matInput type="text" formControlName="label" />
                  <mat-error class="text-danger" *ngIf="
                      filePickerGroup.get('label')?.value?.trim().length == 0
                    ">
                    Enter value to the label</mat-error>
                </mat-form-field>


                <div class="theming-color-items">
                  <div class="color-item">
                    <div class="content">
                      <div class="label">Text Color</div>
                      <div class="value">
                        {{ filePickerGroup.get("textColor")?.value }}
                      </div>
                    </div>
                    <div [style.background-color]="
                        filePickerGroup.get('textColor')?.value
                      " mat-ripple class="color-thumb">
                      <input type="color" formControlName="textColor" />
                    </div>
                  </div>
                  <!-- <ng-container [ngTemplateOutlet]="fontIconTemplate"
                    [ngTemplateOutletContext]="{ formGroup: filePickerGroup }"></ng-container> -->
                </div>
                <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                  Update component
                </button>
              </div>
            </mat-expansion-panel>
            <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
                widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                  .validation.length > 0
              "></ng-container>
          </mat-accordion>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.image">
        <form [formGroup]="imagePickerGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Image Properties</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="
                    imagePickerGroup.get('label')?.value?.trim().length == 0
                  ">Enter value to the label</mat-error>
              </mat-form-field>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text/Icon Color</div>
                    <div class="value">
                      {{ imagePickerGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      imagePickerGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>

              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <!-- done -->
      <ng-container *ngSwitchCase="widgetTypes.button">
        <form [formGroup]="buttonGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Button Styling </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Text</mat-label>
                <input matInput type="text" formControlName="label" (keydown.enter)="$event.preventDefault()" />
                <mat-error class="text-danger" *ngIf="buttonGroup.get('label')?.value?.trim().length == 0">Enter value
                  to the label</mat-error>
              </mat-form-field>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Button Color</div>
                    <div class="value">
                      {{ buttonGroup.get("bgColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="buttonGroup.get('bgColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="bgColor" />
                  </div>
                </div>

                <div class="color-item">
                  <div class="content">
                    <div class="label">Text/Icon Color</div>
                    <div class="value">
                      {{ buttonGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      buttonGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <ng-container [ngTemplateOutlet]="fontIconTemplate"
                [ngTemplateOutletContext]="{ formGroup: buttonGroup }"></ng-container>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <!-- done -->
      <ng-container *ngSwitchCase="widgetTypes.textbox">
        <form [formGroup]="textFieldGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel #expansionPanel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panal" class="d-flex">
                  <div class="panal-title">Input Properties</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="textFieldGroup.get('label')?.value?.trim().length == 0">Enter
                  value to the label</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> Data Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="number">Number</mat-option>
                  <mat-option value="text">Text</mat-option>
                  <mat-option value="password">Password</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Placeholder</mat-label>
                <input matInput type="text" formControlName="placeholder" (keydown.enter)="$event.preventDefault()" />
              </mat-form-field>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ textFieldGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      textFieldGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <!-- need inputs -->
      <ng-container *ngSwitchCase="widgetTypes.singleselectcheckbox">
        <form [formGroup]="checkBoxGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="checkBoxGroup.get('label')?.value?.trim().length == 0">
                  Enter value to the label</mat-error>
              </mat-form-field>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ checkBoxGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      checkBoxGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>

              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <!-- need inputs -->
      <ng-container *ngSwitchCase="widgetTypes.radio">
        <form [formGroup]="radioButtonGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" formControlName="title" />
                <mat-error class="text-danger" *ngIf="
                    radioButtonGroup.get('title')?.value?.trim().length == 0
                  ">Enter value to the title</mat-error>
              </mat-form-field>

              <ng-container *ngFor="
                  let value of selectedWidgetMetaData.widgetDataSource
                    .datasource;
                  let itemIndex = index;
                  let isLast = last
                ">
                <mat-form-field appearance="outline" [color]="
                    showRadioErrorMessage[itemIndex] ? 'warn' : 'primary'
                  ">
                  <mat-label>Label</mat-label>
                  <input matInput type="text" required="true" [value]="value.label"
                    (input)="updateRadioValue($event, itemIndex, value)" />
                  <mat-icon style="cursor: pointer" color="warn" *ngIf="itemIndex > 1" matSuffix
                    (click)="deleteRadioOption(itemIndex)">delete</mat-icon>
                  <mat-hint class="error-message" *ngIf="showRadioErrorMessage[itemIndex] && !isLabelEmpty">Enter value
                    to the label</mat-hint>
                  <mat-hint class="error-message" *ngIf="isLabelEmpty && isLast">Enter value to the label</mat-hint>
                </mat-form-field>
              </ng-container>
              <p style="color: red" *ngIf="showRadioValueError !== ''">
                {{ showRadioValueError }}
              </p>
              <button mat-stroked-button class="w-100 mb-3" color="primary" matTooltip="Add Another Radio Option"
                (click)="AddRadioOption()">
                <mat-icon>add</mat-icon> Add Value
              </button>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ radioButtonGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      radioButtonGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>

          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <!-- done  -->
      <ng-container *ngSwitchCase="widgetTypes.dropdown">
        <form [formGroup]="selectGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput formControlName="label" type="text" />
                <!-- <mat-error class="text-danger" *ngIf="selectGroup.get('label')?.value?.trim().length == 0">Enter value to the label</mat-error> -->
                <mat-error class="text-danger" *ngIf="selectGroup.get('label')?.hasError('required')">Enter value to the
                  label</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>DropDown Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="SingleSelect">Single Select</mat-option>
                  <!-- <mat-option value="MultiSelect" >Multi Select</mat-option>
                  <mat-option value="SingleSelectSearchable">Single Select + Searchable</mat-option>
                  <mat-option value="MultiSelectSearchable">Multi Select + Searchable</mat-option> -->
                </mat-select>
              </mat-form-field>

              <!-- 
              <mat-form-field appearance="outline">
                <mat-label>Placeholder</mat-label>
                <input matInput formControlName="placeholder" type="text" />
              </mat-form-field> -->


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ selectGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      selectGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>

              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>

          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
          <ng-container [ngTemplateOutlet]="dataSource"></ng-container>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <!-- done  -->
      <ng-container *ngSwitchCase="widgetTypes.searchableDropdown">
        <form [formGroup]="selectGroup">
          <mat-form-field appearance="outline" class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> Input Properties </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field appearance="outline">
              <mat-label>Label</mat-label>
              <input matInput formControlName="label" type="text" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label> Data Label</mat-label>
              <mat-select formControlName="type">
                <mat-option value="Text">Text</mat-option>
                <mat-option value="Number">Number</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Placeholder</mat-label>
              <input matInput formControlName="placeholder" type="text" />
            </mat-form-field>
            <div class="color-item">
              <label class="color-label">Text/Icon Color</label>
              <input type="color" formControlName="textColor" />
              <div class="color-preview" [style.background-color]="selectGroup.get('textColor')?.value"></div>
            </div>
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
              Update component
            </button>
          </mat-expansion-panel>

          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate"></ng-container>
          <ng-container [ngTemplateOutlet]="dataSource"></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.date">
        <form [formGroup]="dataPickerGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Date Picker Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="
                    dataPickerGroup.get('label')?.value?.trim().length == 0
                  ">Enter value to the label</mat-error>
              </mat-form-field>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ dataPickerGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      dataPickerGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>


      <ng-container *ngSwitchCase="widgetTypes.imageUploader">
        <form [formGroup]="imageUploaderGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Image Property</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <div class="image-upload mt-4 mb-2" style="margin-top: 15px;" matRipple (click)="fileInput.click()">
                <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none" />
                <img [src]="s3ImageUrl" class="w-100" alt="background" />
                <div class="edit-icon">
                  <mat-icon>edit</mat-icon>
                </div>
              </div>

              <button mat-stroked-button class="mt-2 mb-2" *ngIf="s3ImageUrl !==  imageUploaderSrc" (click)="cropImage()">Crop Image</button>

              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.navText">
        <form [formGroup]="navTextGroup">
          <mat-form-field class="w-100 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Nav Title Properties </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" formControlName="label" />
              </mat-form-field>
              <div class="spacer"></div>
              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ navTextGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      navTextGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
                <!-- <ng-container [ngTemplateOutlet]="fontIconTemplate"
                  [ngTemplateOutletContext]="{ formGroup: textGroup }"></ng-container> -->
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.navButton">
        <form [formGroup]="navButtonGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Button Styling </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Icon</mat-label>
                <mat-select formControlName="image">
                  <ng-container *ngIf="this.widgetIndex == 0; else noIconSelect">
                    <mat-option value="menu" (click)="addMenuPanel()">Menu <mat-icon>menu</mat-icon></mat-option>
                    <mat-option value="arrow_back">Back Arrow <mat-icon>arrow_back</mat-icon></mat-option>
                  </ng-container>
                  <!-- </mat-select> -->
                  <ng-template #noIconSelect>
                    <mat-option value="arrow_forward">Next Arrow <mat-icon>arrow_forward</mat-icon></mat-option>
                    <mat-option value="logout">Logout <mat-icon>logout</mat-icon></mat-option>
                    <mat-option value="sync">Sync <mat-icon>sync</mat-icon></mat-option>
                  </ng-template>
                </mat-select>
              </mat-form-field>

              <ng-container *ngIf="navButtonGroup.get('image')?.value == 'menu' && hasMenu">
                <div class="toggle-container">
                  <ng-container [formGroup]="showMenuGroup">
                    <mat-slide-toggle formControlName="showMenu">
                      Display Menu
                    </mat-slide-toggle>
                  </ng-container>
                </div>

                <mat-list *ngIf="showMenuGroup.get('showMenu')?.value">
                  <div class="toggle-container" *ngFor="
                      let widget of menupaneldetails.widgets;
                      let i = index
                    ">
                    <mat-slide-toggle [checked]="widget.widgetConfig?.enable"
                      (change)="toggleWidgetStatus(widget, i, $event)">
                      {{ widget.widgetLabel }}
                    </mat-slide-toggle>
                  </div>
                  <!-- <mat-list-item *ngFor="let widget of menupaneldetails.widgets; let i = index"  class="toggle-container">
                        <mat-slide-toggle [checked]="widget.widgetConfig?.enable" (change)="toggleWidgetStatus(widget,i,$event)">
                        <span mat-line>{{ widget.widgetLabel }}</span>
                        </mat-slide-toggle>
                      </mat-list-item> -->
                </mat-list>
              </ng-container>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Icon Color</div>
                    <div class="value">
                      {{ navButtonGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      navButtonGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container *ngIf="
              navButtonGroup.get('image')?.value?.trim() !== 'menu' ||
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            " [ngTemplateOutlet]="actionsTemplate"></ng-container>
        </form>
      </ng-container>
      <ng-container *ngSwitchCase="widgetTypes.scanner">
        <form [formGroup]="scannerGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Scanner Property</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="scannerGroup.get('label')?.value?.trim().length == 0">Enter value
                  to the label</mat-error>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Icon Color</div>
                    <div class="value">
                      {{ scannerGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      scannerGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>

              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
        </form>
        <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
            widgetActionsandValidations[selectedWidgetMetaData.widgetType]
              .action.length > 0
          "></ng-container>
        <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
            widgetActionsandValidations[selectedWidgetMetaData.widgetType]
              .validation.length > 0
          "></ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.separator">
        <form [formGroup]="separatorGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Separator Property</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Thickness</mat-label>
                <input matInput type="number" [min]="1" formControlName="thickness" />
                <mat-error *ngIf="separatorGroup.get('thickness')?.hasError('min')">
                  value must be at least 1
                </mat-error>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Color</div>
                    <div class="value">
                      {{ separatorGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      separatorGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.geotag">
        <form [formGroup]="geoGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Geo Property</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="geoGroup.get('label')?.value?.trim().length == 0">Enter value to
                  the label</mat-error>
              </mat-form-field>

              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ geoGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="geoGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.address">
        <form [formGroup]="addressGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel #expansionPanel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panal" class="d-flex">
                  <div class="panal-title">Address Properties</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="ps-4 mat-form-field-container">
              <mat-form-field appearance="outline">
                <mat-label>Display Type</mat-label>
                <mat-select formControlName="matUiType">
                   <mat-option [value]="matUiTypes.filled">Filled</mat-option>
                    <mat-option [value]="matUiTypes.outlined">Outlined</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Label</mat-label>
                <input matInput type="text" formControlName="label" />
                <mat-error class="text-danger" *ngIf="addressGroup.get('label')?.value?.trim().length == 0">
                  Enter value to the label</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Placeholder</mat-label>
                <input matInput type="text" formControlName="placeholder" />
              </mat-form-field>


              <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">
                      {{ addressGroup.get("textColor")?.value }}
                    </div>
                  </div>
                  <div [style.background-color]="
                      addressGroup.get('textColor')?.value
                    " mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
          <ng-container [ngTemplateOutlet]="validationsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .validation.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.datalist">
        <form [formGroup]="dataListGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panal" class="d-flex">
                  <div class="panal-title">Data List Properties</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="ps-4 mat-form-field-container">
              <mat-accordion togglePosition="before" displayMode="flat">
                <mat-form-field class="w-100 m-1" appearance="outline">
                  <mat-label>Data List Type</mat-label>
                  <mat-select (selectionChange)="onSelectChange()" formControlName="type" disableRipple>
                    <mat-option *ngFor="let option of ['Card']" [value]="option">
                      {{ option }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-100 m-1" appearance="outline">
                  <mat-label>Entity</mat-label>
                  <mat-select (click)="isEntityClicked()" (selectionChange)="onEntitySelected()"
                    formControlName="entity" disableRipple>
                    <mat-option *ngFor="let option of listOfEntitiesOfApplication" [value]="option.entity_id">
                      {{ option.entity_name }}</mat-option>
                  </mat-select>
                  <mat-hint class="error-message small" *ngIf="
                      isEntityTouched && listOfEntitiesOfApplication.length == 0
                    ">Entity not found. Please create an entity first.</mat-hint>
                  <mat-error class="small" *ngIf="
                      dataListGroup.get('entity')?.hasError('required') &&
                      listOfEntitiesOfApplication.length > 0
                    ">Please select an option from the dropdown</mat-error>
                  <mat-error class="small" *ngIf="
                      dataListGroup.get('entity')?.hasError('required') &&
                      listOfEntitiesOfApplication.length == 0
                    ">Entity not found. Please create an entity first.</mat-error>
                </mat-form-field>
                <div class="pt-2">
                  <mat-expansion-panel expanded="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Card Design</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div class="mb-inner-pennal">
                        <h3 class="titl">LHS</h3>
                        <div formArrayName="lhsItems" class="d-flex flex-column gap-2 mb-2">
                          <ng-container *ngFor="
                              let item of lhsItems.controls;
                              let leftIndex = index
                            ">
                            <div [formGroupName]="leftIndex" class="d-flex gap-2 align-items-center">
                              <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Select Field</mat-label>
                                <mat-select formControlName="widgetId" disableRipple>
                                  <mat-option *ngFor="
                                      let option of getFilteredOptions(
                                        leftIndex,
                                        'lhs'
                                      )
                                    " [value]="option.widgetId">
                                    {{
                                    option?.widgetLabel
                                    ? option?.widgetLabel
                                    : ""
                                    }}</mat-option>
                                </mat-select>
                              </mat-form-field>
                              <button mat-icon-button color="warn" (click)="removeLhsFieldsInCard(leftIndex)"
                                aria-label="Example icon button with a menu icon">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                            <mat-error *ngIf="
                                listOfWidgetsOfEntity.length == 0 &&
                                isLhsclicked
                              ">No attributes found in the entity</mat-error>
                          </ng-container>
                        </div>
                        <button mat-stroked-button (click)="addLhsFieldsInCard()" class="w-100" color="primary"
                          [disabled]="
                            (lhsItems.controls?.length ?? 0) +
                              (rhsItems.controls?.length ?? 0) ===
                            listOfWidgetsOfEntity?.length
                          ">
                          <mat-icon>add</mat-icon> Add Field
                        </button>
                      </div>
                      <div class="mb-inner-pennal">
                        <h3 class="titl">RHS</h3>
                        <div formArrayName="rhsItems" class="d-flex flex-column gap-2 mb-2">
                          <ng-container *ngFor="
                              let item of rhsItems.controls;
                              let rightIndex = index
                            ">
                            <div [formGroupName]="rightIndex" class="d-flex gap-2 align-items-center">
                              <mat-form-field class="w-100" appearance="outline">
                                <mat-label>Select Field</mat-label>
                                <mat-select formControlName="widgetId" disableRipple>
                                  <mat-option *ngFor="
                                      let option of getFilteredOptions(
                                        rightIndex,
                                        'rhs'
                                      )
                                    " [value]="option.widgetId">
                                    {{
                                    option?.widgetLabel
                                    ? option?.widgetLabel
                                    : ""
                                    }}</mat-option>
                                </mat-select>
                              </mat-form-field>
                              <button mat-icon-button color="warn" (click)="removeRhsFieldsInCard(rightIndex)"
                                aria-label="Example icon button with a menu icon">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                            <mat-error *ngIf="
                                listOfWidgetsOfEntity.length == 0 &&
                                isRhsclicked
                              ">No attributes found in the entity</mat-error>
                          </ng-container>
                        </div>
                        <button mat-stroked-button (click)="addRhsFieldsInCard()" class="w-100" color="primary"
                          [disabled]="
                            (lhsItems.controls?.length ?? 0) +
                              (rhsItems.controls?.length ?? 0) ===
                            listOfWidgetsOfEntity?.length
                          ">
                          <mat-icon>add</mat-icon> Add Field
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div class="pt-2">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Data List Display View</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <mat-list>
                        <mat-list-item class="app-name" *ngFor="
                            let item of listOfWidgetsOfEntity;
                            let j = index
                          " class="">
                          <div class="app-name">
                            <p class="title ellipsis-input" [matTooltip]="item.widgetLabel">
                              {{ item.widgetLabel | titlecase }}
                            </p>
                            <mat-slide-toggle [(ngModel)]="item.show" [ngModelOptions]="{ standalone: true }"
                              (change)="updateWidgetValues()"></mat-slide-toggle>
                          </div>
                        </mat-list-item>
                      </mat-list>
                      <mat-error class="gap-3" *ngIf="listOfWidgetsOfEntity.length == 0">No attributes found in the
                        entity</mat-error>
                    </div>
                    <button mat-stroked-button class="w-100 mt-3" color="primary"
                      (click)="createOrUpdateDataListViewPage()">
                      Create Data List View Page
                    </button>
                  </mat-expansion-panel>
                </div>
                <!-- <div class="theming-color-items">
                <div class="color-item">
                  <div class="content">
                    <div class="label">Text Color</div>
                    <div class="value">{{addressGroup.get('textColor')?.value}}</div>
                  </div>
                  <div [style.background-color]="addressGroup.get('textColor')?.value" mat-ripple class="color-thumb">
                    <input type="color" formControlName="textColor" />
                  </div>
                </div>
                <ng-container [ngTemplateOutlet]="fontIconTemplate"
                  [ngTemplateOutletContext]="{ formGroup: addressGroup }"></ng-container>
              </div> -->
                <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                  Update component
                </button>
              </mat-accordion>
            </div>
          </mat-expansion-panel>
          <!-- <ng-container [ngTemplateOutlet]="actionsTemplate"></ng-container>
        <ng-container [ngTemplateOutlet]="validationsTemplate"></ng-container> -->
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.faceId">
        <form [formGroup]="faceIdGroup">
          <mat-form-field appearance="outline">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Face Id Property</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.fingerPrint">
        <form [formGroup]="touchIdGroup">
          <mat-form-field class="w-100 rounded-0 mat-no-hint">
            <mat-label>Key</mat-label>
            <input matInput type="text" formControlName="key" />
          </mat-form-field>
          <mat-divider></mat-divider>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Finger Print Property</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="ps-4 mat-form-field-container">
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateWidgetValues()">
                Update component
              </button>
            </div>
          </mat-expansion-panel>
          <ng-container [ngTemplateOutlet]="actionsTemplate" *ngIf="
              widgetActionsandValidations[selectedWidgetMetaData.widgetType]
                .action.length > 0
            "></ng-container>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.table" >
        <form [formGroup]="tableGroup">
          <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
          <mat-divider></mat-divider>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="panal" class="d-flex">
                  <div class="panal-title">Chart Properties</div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
  
            <div class="mat-form-field-container">
              <mat-accordion togglePosition="before" displayMode="flat">
                <mat-form-field class="w-100 rounded-0" appearance="outline">
                  <mat-label>Title</mat-label>
                  <input matInput type="text" formControlName="title" />
                </mat-form-field>
                <mat-divider></mat-divider>
  
                <div class="pt-2">
                  <mat-expansion-panel expanded="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Data Source</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div class="mb-inner-pennal">
                        <mat-form-field class="w-100 m-1" appearance="outline">
                          <mat-label>Data Source Type</mat-label>
                          <mat-select formControlName="dataSourceType" disableRipple>
                            <mat-option *ngFor="let option of chartDataSourceTypes" [value]="option.value">
                              {{ option.label }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <ng-container *ngIf="
                          tableGroup.value.dataSourceType == 'api'
                        ">
                      <div [formGroup]="selectedApiGroup">
                        <mat-form-field  class="w-100 m-1" appearance="outline">
                        <mat-label>Select Api</mat-label>
                        <mat-select formControlName="selectedApi" >
                          <mat-option *ngFor="let api of userApis" [value]="api.apiId">{{api.apiName}}</mat-option>
                        </mat-select>
                       </mat-form-field>
                      </div>
                        <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                            getApiOrEntityDefinitionBasedOnForm(
                              'api',
                              selectedApiGroup.get('selectedApi')?.value
                            )
                          ">
                          Get Api Definition
                        </button>
                      </ng-container>
                      <ng-container *ngIf="
                          tableGroup.value.dataSourceType ==
                          'entity'
                        ">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Entity</mat-label>
                          <mat-select formControlName="entity">
                            <mat-option *ngFor="
                                let option of listOfEntitiesOfMobAndWebApplication
                              " [value]="option.entity_id">
                              {{ option.entity_name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                            getApiOrEntityDefinitionBasedOnForm(
                              'entity',
                              tableGroup.get('entity')?.value
                            )
                          ">
                          Get Entity Definition
                        </button>
                      </ng-container>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
                  <div class="pt-2">
                    <mat-expansion-panel expanded="false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="panal" class="d-flex">
                            <div class="panal-title">Data Properties</div>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="d-flex flex-column gap-3">
                        <div formGroupName="dataProperties" class="mb-inner-pennal">
                          <mat-form-field class="w-100 rounded-0" appearance="outline">
                            <mat-label>Table Headers</mat-label>
                            <mat-select formControlName="tableHeaders" multiple>
                              <mat-option *ngFor="let option of apikeys" [value]="option">
                                {{ option }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field class="w-100 rounded-0" appearance="outline">
                            <mat-label>Number of rows per page</mat-label>
                            <input matInput type="number" formControlName="rowsPerPage"/>
                          </mat-form-field>

                          <mat-slide-toggle formControlName="filterOptions" labelPosition="before" >Sort & Filter Options</mat-slide-toggle>

                        </div>
                      </div>
                    </mat-expansion-panel>
                  </div>
               
                <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateTableWidgetValues()">
                  Update component
                </button>
              </mat-accordion>
            </div>
          </mat-expansion-panel>
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.barChart" [ngTemplateOutlet]="barOrLineCharConfig">
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.lineChart" [ngTemplateOutlet]="barOrLineCharConfig">
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.pieChart" [ngTemplateOutlet]="barOrLineCharConfig">
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.map" [ngTemplateOutlet]="mapConfig">
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.stackBarChart" [ngTemplateOutlet]="barOrLineCharConfig">
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.donutChart" [ngTemplateOutlet]="barOrLineCharConfig">
      </ng-container>

      <ng-container *ngSwitchCase="widgetTypes.fixedBarChart" [ngTemplateOutlet]="barOrLineCharConfig">
      </ng-container>

      <ng-container *ngSwitchDefault>
        <p>Development in progress for {{ displayedContent }}</p>
      </ng-container>
    </div>

    <ng-template #actionsTemplate>
      <mat-expansion-panel togglePosition="before" displayMode="flat">
        <mat-expansion-panel-header>
          <mat-panel-title class="m-0">
            <span class="flex-fill"> Click Actions</span>
            <mat-chip>{{ selectedActions.length }}</mat-chip>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ps-4 sub-actions-accordion">
          <mat-accordion togglePosition="before" displayMode="flat">
            <div *ngFor="let action of selectedActions; let i = index">
              <mat-expansion-panel *ngIf="action == buttonActionsCpy[1]" expanded>
                <mat-expansion-panel-header (click)="fieldsGenerator()">
                  <mat-panel-title [class.fontsize]="navButtonGroup.get('pageName')?.value">
                    <p class="label">Navigation</p>
                    <p class="value" *ngIf="!navigationGroup.get('pageName')?.value">
                      Select Page
                    </p>
                    <p class="value" *ngIf="navigationGroup.get('pageName')?.value">
                      {{ navigationGroup.get("pageName")?.value | titlecase }}
                    </p>
                  </mat-panel-title>
                  <button mat-icon-button (click)="deleteAction(i, action)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-expansion-panel-header>

                <form [formGroup]="navigationGroup" class="mat-form-field-container">
                  <mat-form-field appearance="outline">
                    <mat-label>Select Page</mat-label>
                    <mat-select formControlName="pageName">
                      <ng-container *ngFor="let item of pageNames">
                        <mat-option [value]="item">{{
                          item | titlecase
                          }}</mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                </form>
                <div class="actions">
                  <button mat-stroked-button color="primary" (click)="deleteAction(i, action)">
                    Cancel
                  </button>
                  <button mat-flat-button color="primary" color="primary"
                    (click)="addActions(widgetActionTypes.navigation)">
                    Save
                  </button>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel *ngIf="action == buttonActionsCpy[2]" expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div>Conditional</div>
                  </mat-panel-title>
                  <button mat-icon-button (click)="deleteAction(i, action)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-expansion-panel-header>

                <ng-container *ngIf="listOfconditionalActions">
                  <mat-accordion togglePosition="before" displayMode="flat">
                    <ng-container *ngFor="
                        let item of listOfconditionalActions;
                        let idx = index
                      ">
                      <mat-expansion-panel>
                        <mat-expansion-panel-header (click)="setConditionalValue(item, idx)" class="mat-list-item"
                          mat-ripple>
                          <mat-panel-title>
                            <div style="color: white">
                              <ng-container *ngFor="let formDetails of pageNamesandIdList">
                                <p *ngIf="item.action == formDetails.key" style="color: white">
                                  {{ formDetails.label }}
                                </p>
                              </ng-container>
                            </div>
                          </mat-panel-title>
                          <button mat-icon-button (click)="deleteConditionalAction(idx, action)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </mat-expansion-panel-header>
                        <div class="mat-form-field-container">
                          <form [formGroup]="conditionalActionUpdatedGroup">
                            <mat-form-field class="w-100" appearance="outline">
                              <mat-label>Go To</mat-label>
                              <mat-select formControlName="pageName">
                                <ng-container *ngFor="let item of pageNamesandIdList">
                                  <mat-option [value]="item.key">{{
                                    item.label | titlecase
                                    }}</mat-option>
                                </ng-container>
                              </mat-select>
                            </mat-form-field>
                          </form>
                          <form>
                            <mat-form-field class="example-chip-list" class="w-100" appearance="outline">
                              <mat-label>Parameters</mat-label>
                              <mat-chip-grid #chipGrid aria-label="widget selection">
                                <mat-chip-row *ngFor="
                                    let field of msFieldslistUpdate;
                                    let i = index
                                  " (removed)="removeParameterUpdate(field, i)">
                                  {{ field }}
                                  <button matChipRemove [attr.aria-label]="'remove ' + field">
                                    <mat-icon>cancel</mat-icon>
                                  </button>
                                </mat-chip-row>
                              </mat-chip-grid>
                              <input placeholder="Select Field" #payloadInput [formControl]="fieldCtrl"
                                [matChipInputFor]="chipGrid" [matAutocomplete]="autoParameterUpdate"
                                [matChipInputSeparatorKeyCodes]="
                                  separatorKeysCodes
                                " (matChipInputTokenEnd)="add($event)" />
                              <mat-autocomplete #autoParameterUpdate="matAutocomplete" (optionSelected)="
                                  selectedParameterUpdate($event)
                                ">
                                <mat-option *ngFor="let field of formWidgetsUpdate" [value]="field">
                                  {{ field.widgetLabel }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </form>
                        </div>

                        <div class="mat-form-field-container">
                          <ng-container *ngIf="conditionalKeyValue.length > 0">
                            <ng-container *ngFor="
                                let item of conditionalKeyValue;
                                let i = index
                              ">
                              <mat-form-field class="example-chip-list" class="w-100 mt-2" appearance="outline">
                                <mat-label>{{
                                  getLabelName(item.key)
                                  }}</mat-label>
                                <mat-icon (click)="
                                    delectChipGridItemUpdateChip(i, item.key)
                                  " color="warn" matSuffix>remove</mat-icon>
                                <mat-chip-grid #chipGrid aria-label="Enter values">
                                  <mat-chip-row *ngFor="
                                      let value of item.values;
                                      let idx = index
                                    " (removed)="
                                      removeItemValueUpdateChip(item, i, idx)
                                    " [editable]="true" (edited)="
                                      editItemValue(value, item, $event)
                                    " [aria-description]="
                                      'press enter to edit ' + value
                                    ">
                                    {{ value }}
                                    <button matChipRemove [attr.aria-label]="'remove ' + value">
                                      <mat-icon>cancel</mat-icon>
                                    </button>
                                  </mat-chip-row>
                                </mat-chip-grid>
                                <input placeholder="Select Field" #payloadInput [formControl]="fieldCtrl"
                                  [matChipInputFor]="chipGrid" [matAutocomplete]="dropdownAutoDropdown"
                                  [matChipInputSeparatorKeyCodes]="
                                    separatorKeysCodes
                                  " (matChipInputTokenEnd)="addUpdateChip($event)"
                                  (click)="onInputClickUpdateChip(item, i)" />
                                <mat-autocomplete #dropdownAutoDropdown="matAutocomplete" (optionSelected)="
                                    selectedUpdateChip($event, i)
                                  ">
                                  <mat-option *ngFor="
                                      let field of dropdownValuesUpdateChip
                                    " [value]="field">
                                    {{ field.label }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                            </ng-container>
                          </ng-container>
                        </div>

                        <ng-container *ngIf="formWidgetsMenuUpdate.length > 0">
                          <button mat-stroked-button class="w-100 mt-2" [matMenuTriggerFor]="widgetMenu">
                            <mat-icon>add</mat-icon> Add Conditional Field
                          </button>
                          <mat-menu #widgetMenu="matMenu">
                            <ng-container *ngFor="
                                let action of formWidgetsMenuUpdate;
                                let ind = index
                              ">
                              <button mat-menu-item (click)="addFieldConditionUpdate(ind, action)" mat-ripple>
                                {{ action.widgetLabel }}
                              </button>
                            </ng-container>
                          </mat-menu>
                        </ng-container>

                        <div class="actions">
                          <button mat-flat-button color="primary" color="primary" (click)="
                              updateConditionalActions(
                                widgetActionTypes.conditionalNavigation,
                                idx
                              )
                            ">
                            Update
                          </button>
                        </div>
                      </mat-expansion-panel>
                    </ng-container>
                  </mat-accordion>
                </ng-container>

                <div class="mat-form-field-container">
                  <form [formGroup]="conditionalActionGroup">
                    <mat-form-field class="w-100 mt-3" appearance="outline">
                      <mat-label>Go To</mat-label>
                      <mat-select formControlName="pageName">
                        <ng-container *ngFor="let item of pageNamesandIdList">
                          <mat-option [value]="item.key">{{
                            item.label
                            }}</mat-option>
                        </ng-container>
                      </mat-select>
                      <mat-error *ngIf="
                          conditionalActionGroup
                            .get('pageName')
                            ?.hasError('required')
                        ">Please select a page</mat-error>
                    </mat-form-field>
                    <div class="mat-form-field-container mt-2">
                      <ng-container *ngFor="
                          let item of NavigationConditionals;
                          let itemIndex = index
                        ">
                        <form>
                          <mat-form-field class="example-chip-list" class="w-100" appearance="outline">
                            <mat-label>{{ item.key.widgetLabel }}</mat-label>
                            <mat-icon (click)="delectChipGridItem(itemIndex, item)" color="warn"
                              matSuffix>remove</mat-icon>
                            <mat-chip-grid #chipGrid aria-label="Enter values">
                              <mat-chip-row *ngFor="let value of item.values; let i = index" (removed)="
                                  removeItemValuenew(item, itemIndex, i)
                                " [editable]="true" (edited)="editItemValue(value, item, $event)" [aria-description]="
                                  'press enter to edit ' + value
                                ">
                                {{ value }}
                                <button matChipRemove [attr.aria-label]="'remove ' + value">
                                  <mat-icon>cancel</mat-icon>
                                </button>
                              </mat-chip-row>
                            </mat-chip-grid>
                            <ng-container *ngIf="
                                item.key.widgetType === widgetTypes.dropdown
                              ">
                              <input placeholder="Select Field" #payloadInput [formControl]="fieldCtrl"
                                [matChipInputFor]="chipGrid" [matAutocomplete]="dropdownAutoDropdown"
                                [matChipInputSeparatorKeyCodes]="
                                  separatorKeysCodes
                                " (matChipInputTokenEnd)="addnew($event)"
                                (click)="onInputClick(item.key, itemIndex)" />
                              <mat-autocomplete #dropdownAutoDropdown="matAutocomplete" (optionSelected)="
                                  selectednew($event, widgetTypes.dropdown)
                                ">
                                <mat-option *ngFor="let field of dropdownValues" [value]="field">
                                  {{ field.label | titlecase }}
                                </mat-option>
                              </mat-autocomplete>
                            </ng-container>

                            <ng-container *ngIf="item.key.widgetType === widgetTypes.radio">
                              <input placeholder="Select Field" #payloadInput [formControl]="fieldCtrl"
                                [matChipInputFor]="chipGrid" [matAutocomplete]="dropdownAutoRadio"
                                [matChipInputSeparatorKeyCodes]="
                                  separatorKeysCodes
                                " (matChipInputTokenEnd)="addnew($event)"
                                (click)="onInputClick(item.key, itemIndex)" />
                              <mat-autocomplete #dropdownAutoRadio="matAutocomplete" (optionSelected)="
                                  selectednew($event, widgetTypes.radio)
                                ">
                                <mat-option *ngFor="let field of dropdownValues" [value]="field">
                                  {{ field.label | titlecase }}
                                </mat-option>
                              </mat-autocomplete>
                            </ng-container>

                            <ng-container *ngIf="
                                item.key.widgetType ===
                                widgetTypes.singleselectcheckbox
                              ">
                              <input placeholder="Select Field" #payloadInput [formControl]="fieldCtrl"
                                [matChipInputFor]="chipGrid" [matAutocomplete]="dropdownAutoCheckBox"
                                [matChipInputSeparatorKeyCodes]="
                                  separatorKeysCodes
                                " (matChipInputTokenEnd)="addnew($event)"
                                (click)="onInputClick(item.key, itemIndex)" />
                              <mat-autocomplete #dropdownAutoCheckBox="matAutocomplete" (optionSelected)="
                                  selectednew(
                                    $event,
                                    widgetTypes.singleselectcheckbox
                                  )
                                ">
                                <mat-option *ngFor="let field of dropdownValues" [value]="field">
                                  {{ field | titlecase }}
                                </mat-option>
                              </mat-autocomplete>
                            </ng-container>
                          </mat-form-field>
                        </form>
                      </ng-container>
                    </div>
                    <div>
                      <ng-container *ngIf="formWidgetsMenu.length > 0">
                        <button mat-stroked-button class="w-100 mt-3" [matMenuTriggerFor]="widgetMenu">
                          <mat-icon>add</mat-icon> Add Conditional Field
                        </button>
                        <mat-menu #widgetMenu="matMenu">
                          <ng-container *ngFor="
                              let action of formWidgetsMenu;
                              let ind = index
                            ">
                            <button mat-menu-item (click)="addFieldCondition(ind, action)" mat-ripple>
                              {{ action.widgetLabel }}
                            </button>
                          </ng-container>
                        </mat-menu>
                      </ng-container>

                      <div class="actions">
                        <button mat-stroked-button color="primary" (click)="deleteAction(i, action)">
                          Cancel
                        </button>
                        <button mat-flat-button color="primary" color="primary"
                          (click)="addActions(widgetActionTypes.conditionalNavigation)">
                          Add
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </mat-expansion-panel>
              <mat-expansion-panel *ngIf="action == buttonActionsCpy[0]" expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div>Submit</div>
                  </mat-panel-title>
                  <button mat-icon-button (click)="deleteAction(i, action)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-expansion-panel-header>
                <form [formGroup]="previewGroup">
                  <div class="app-name mt-2 m-lg-2">
                    <h4 class="title">Preview</h4>
                    <mat-slide-toggle formControlName="preview" color="primary"></mat-slide-toggle>
                  </div>
                  <div class="actions">
                    <button mat-stroked-button color="primary" (click)="deleteAction(i, action)">
                      Cancel
                    </button>
                    <button mat-flat-button color="primary" color="primary"
                      (click)="addActions(widgetActionTypes.submit)">
                      Save
                    </button>
                  </div>
                </form>
              </mat-expansion-panel>
            </div>
          </mat-accordion>

          <div *ngIf="buttonActions?.length > 0" class="mt-2">
            <div class="mat-form-field-container">
              <form [formGroup]="actionForm">
                <mat-form-field class="w-100 mt-2" appearance="outline">
                  <mat-label>Select Action Type</mat-label>
                  <mat-select formControlName="selectedAction" disableRipple>
                    <mat-option *ngFor="let option of buttonActions" [value]="option"
                      (click)="addAction(actionForm.get('selectedAction')?.value)">
                      {{ option | titlecase}}</mat-option>
                  </mat-select>
                  </mat-form-field>
              </form>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </ng-template>

    <ng-template #validationsTemplate>
      <mat-expansion-panel togglePosition="before" displayMode="flat">
        <mat-expansion-panel-header>
          <mat-panel-title class="m-0">
            <span class="flex-fill"> Validation</span>
            <mat-chip>{{
              selectedWidgetMetaData.widgetConfig?.validations?.length || 0
              }}</mat-chip>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ps-4">
          <ng-container>
            <mat-list role="list">
              <mat-list-item class="item-selected" [class.active]="i === selectedValidationIndex && editMode"
                role="listitem" *ngFor="
                  let validation of selectedWidgetMetaData.widgetConfig
                    .validations;
                  let i = index
                ">
                <ng-container *ngIf="
                    selectedWidgetMetaData &&
                    selectedWidgetMetaData.widgetConfig &&
                    selectedWidgetMetaData.widgetConfig.validations &&
                    selectedWidgetMetaData.widgetConfig.validations.length > 0
                  ">
                  <div class="d-flex gap-3 flex-nowrap align-items-center py-2">
                    <div class="item-start flex-fill">
                      <h4 class="title">
                        {{ validation.validation_type }}:
                        {{ validation.validation_value }}
                      </h4>
                      <p>{{ validation?.error_message }}</p>
                    </div>
                    <div class="item-end">
                      <button mat-icon-button matSuffix (click)="editValidations(validation)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button matSuffix (click)="deleteValidation(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </mat-list-item>
            </mat-list>
            <div *ngIf="showValidationForm">
              <div class="mat-form-field-container">
                <form [formGroup]="validationForm">
                  <mat-form-field class="w-100 mt-3" appearance="outline">
                    <mat-label>Validation Type</mat-label>
                    <mat-select formControlName="selectedValidationType"
                      (selectionChange)="onSelectChange()" disableRipple>
                      <mat-option *ngFor="let option of inputFieldValidationData" [value]="option">
                        {{ option }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span class="error-message" *ngIf="isSelectedValidationType">Please select Validation Type</span>
                  <mat-form-field *ngIf="checkValidationMatched(validationNames.required)" class="w-100" appearance="outline">
                    <mat-label>Error Message</mat-label>
                    <input matInput type="text" formControlName="requiredMessage" placeholder="Enter error message"
                      (input)="onLengthAdd($event)" />
                  </mat-form-field>

                  <mat-form-field *ngIf="checkValidationMatched(validationNames.minimum_length) || checkValidationMatched(validationNames.maximum_length)" class="w-100" appearance="outline">
                    <input matInput type="number" formControlName="validationValue" (input)="onLengthAdd($event)"
                      [placeholder]="this.validationForm.get('selectedValidationType')?.value" />
                    <mat-hint class="text-danger" *ngIf="
                        isLengthValidation &&
                        checkValidationMatched(validationNames.maximum_length)
                      ">Maximum length should be greater than Minimum
                      length</mat-hint>
                    <mat-hint class="text-danger" *ngIf="
                        isLengthValidation &&
                        checkValidationMatched(validationNames.minimum_length)
                      ">Minimum length should be lesser than Maximum
                      length</mat-hint>
                  </mat-form-field>
                  <span class="error-message" *ngIf="isValidationExist">Validation already exists!</span>
                  <span class="error-message" *ngIf="isMessageValidation">Enter value to add Validation</span>
                </form>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addValidation()" [disabled]="
                  isLengthValidation || isMessageValidation || isValid
                ">
                <mat-icon>add</mat-icon>
                {{ editMode ? "Update" : "Add" }} Validation
              </button>
            </div>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </ng-template>

    <ng-template #dataSource>
      <mat-expansion-panel togglePosition="before" displayMode="flat">
        <mat-expansion-panel-header>
          <mat-panel-title class="m-0">
            <span class="flex-fill"> Data Source</span>
            <ng-container *ngIf="
                (dataSourceValues && dataSourceValues.length > 0) || typeApi
              "><mat-chip>1</mat-chip></ng-container>
            <ng-container *ngIf="dataSourceValues.length < 1 && !typeApi"><mat-chip>0</mat-chip></ng-container>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ps-4">
          <ng-container *ngIf="dataSourceApi"> </ng-container>
          <ng-container *ngIf="dataSourceValues"> </ng-container>
          <form [formGroup]="dataSourceTypeForm" class="mat-form-field-container">
            <mat-form-field appearance="outline">
              <mat-label> Drop Down Type</mat-label>
              <mat-select formControlName="dataSourceType">
                <mat-option *ngFor="let type of dataSourceTypes" [value]="type">{{ type }}</mat-option>
              </mat-select>
            </mat-form-field>
          </form>
          <ng-container *ngIf="dataSourceTypeForm.get('dataSourceType')?.value === 'API'">
            <button class="w-100 mt-3 rounded-0" color="accent" mat-stroked-button
              (click)="openAuthDialog(AuthDataSource, 'Add')">
              Need Authentication
            </button>

            <div class="json-container" *ngIf="authApiData.authApiUrl" (click)="openAuthDialog(AuthDataSource, 'Edit')">
              {{ authApiData | json }}
            </div>

            <form [formGroup]="apiForm">
              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>API URL</mat-label>
                <input matInput formControlName="apiUrl" />
              </mat-form-field>

              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>Method</mat-label>
                <mat-select formControlName="method">
                  <mat-option value="GET">GET</mat-option>
                  <mat-option value="POST">POST</mat-option>
                  <mat-option value="PUT">PUT</mat-option>
                  <mat-option value="DELETE">DELETE</mat-option>
                </mat-select>
              </mat-form-field>

              <form>
                <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                  <mat-label>Payload</mat-label>
                  <mat-chip-grid #chipGrid2 aria-label="widget selection">
                    <mat-chip-row *ngFor="let field of msFieldslist" (removed)="remove(field)">
                      {{ field.widgetLabel }}
                      <button matChipRemove [attr.aria-label]="'remove ' + field">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip-row>
                  </mat-chip-grid>
                  <input placeholder="field" #payloadInput [formControl]="fieldCtrl" [matChipInputFor]="chipGrid2"
                    [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)" />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                    <mat-option *ngFor="let field of formWidgets" [value]="field">
                      {{ field.widgetLabel }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon matSuffix
                    matTooltip="Select the Field from the dropdown ,the selected fields values will be sent as payloads"
                    matTooltipPosition="after">info</mat-icon>
                </mat-form-field>
              </form>

              <button mat-stroked-button class="w-100 mt-3" color="accent" (click)="makeApiCall()">
                Get API Responce Keys
              </button>
              <ng-container *ngIf="apiForm.valid">
                <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                  <mat-label>Response Parameter</mat-label>
                  <mat-select formControlName="responseParameter">
                    <ng-container *ngFor="let key of apikeys">
                      <mat-option [value]="key">{{ key }}</mat-option>
                    </ng-container>
                  </mat-select>
                  <mat-icon matSuffix
                    matTooltip="Enter the key name you want to assign to the dropdown Ex: username, if your data consists of Userdetails"
                    matTooltipPosition="after">info</mat-icon>
                </mat-form-field>
                <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addDataSource()">
                  Save API Details
                </button>
              </ng-container>
            </form>
          </ng-container>

          <ng-container *ngIf="dataSourceTypeForm.get('dataSourceType')?.value === 'Manual'">
            <mat-list role="list">
              <mat-list-item class="item-selected" [class.active]="i === selectedDataSourceIndex && editMode"
                role="listitem" *ngFor="let obj of dataSourceValues; let i = index">
                <ng-container *ngIf="dataSourceValues">
                  <div class="d-flex gap-3 flex-nowrap align-items-center py-2 ps-4">
                    <div class="item-start flex-fill">
                      <h4 class="title text-word-break text-ellipsis">
                        {{ obj }}
                      </h4>
                    </div>
                    <div class="item-end">
                      <button mat-icon-button matSuffix (click)="editDatasourceValues(i)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button mat-icon-button matSuffix (click)="deleteDatasourceValue(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </mat-list-item>
            </mat-list>
            <!-- Values Form -->
            <form [formGroup]="valuesForm">
              <div>
                <form [formGroup]="valuesForm" class="mat-form-field-container">
                  <mat-form-field class="w-100 mt-3" appearance="outline">
                    <mat-label>Label</mat-label>
                    <input matInput type="text" formControlName="label" />
                  </mat-form-field>
                  <span class="error-message" *ngIf="lableExisted">Value already exists!</span>
                  <span class="error-message" *ngIf="requiredField">please enter label!</span>
                </form>
                <button mat-stroked-button class="w-100 mt-3" color="primary" *ngIf="!editMode"
                  (click)="addDataSourceValue()">
                  <mat-icon>add</mat-icon> Add Value
                </button>
                <button mat-stroked-button class="w-100 mt-3" color="primary" *ngIf="editMode"
                  (click)="updateEditedDataSource()">
                  <mat-icon>add</mat-icon> Update Value
                </button>
              </div>

              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="addDataSource()">
                Save Values
              </button>
            </form>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </ng-template>

    <ng-template #apiDataSourceConfig>
      <mat-dialog-content>
        <form [formGroup]="apiDataSourceApiConfigForm">
          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
            <mat-label>Api Url</mat-label>
            <input matInput formControlName="apiUrl" />
          </mat-form-field>
          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
            <mat-label>Http method</mat-label>
            <mat-select formControlName="httpMethod">
              <mat-option value="GET">Get</mat-option>
              <mat-option value="POST">Post</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="outline toggle-container custom-toggle-container">
            <mat-slide-toggle formControlName="headerParamsRequired">
              <span class="font-add">Headers Required</span>
            </mat-slide-toggle>
          </div>
          <ng-container *ngIf="apiDataSourceApiConfigForm.value.headerParamsRequired">
            <div formArrayName="headers" class="gap-3">
                <mat-card>
                    <mat-card-header class="api-header">
                        <div class="d-flex align-items-center">
                            <mat-card-title class="api-header-title ">
                                Api Headers
                            </mat-card-title>
                        </div>
                        <div class="api-header-button"> 
                            <button mat-icon-button (click)="addApiHeaderParams()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </mat-card-header>

                <mat-card-content>
                  <ng-container *ngFor="let param of headers.controls; let index = index">
                    <div class="row flex-nowrap align-items-center" [formGroupName]="index">
                      <div class="col">
                        <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                          <mat-label>Key</mat-label>
                          <input matInput formControlName="key" />
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                          <mat-label>Value</mat-label>
                          <input matInput formControlName="value" />
                        </mat-form-field>
                      </div>
                      <div class="col-auto">
                        <button mat-icon-button matTooltip="Warn" color="warn" (click)="deleteHeader(index)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>

                  </ng-container>
                </mat-card-content>
              </mat-card>
            </div>
          </ng-container>
          <ng-container *ngIf="apiDataSourceApiConfigForm.value.httpMethod === 'POST'">
            <div formArrayName="apiPostData">
              <mat-card>
                 <mat-card-header class="api-header">
                  <div class="d-flex align-items-center">
                      <mat-card-title class="api-header-title ">
                          Api Post Data 
                      </mat-card-title>
                  </div>
                  <div class="api-header-button"> 
                      <button mat-icon-button (click)="addApiPostParams()">
                          <mat-icon>add</mat-icon>
                      </button>
                  </div>
                  </mat-card-header>
                  <mat-card-content>
                    <ng-container *ngFor="
                    let param of apiPostData.controls;
                    let index = index
                  ">                      <div class="row flex-nowrap align-items-center" [formGroupName]="index">
                        <div class="col">
                          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                            <mat-label>Key</mat-label>
                            <input matInput formControlName="key" />
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                            <mat-label>Value</mat-label>
                            <input matInput formControlName="value" />
                          </mat-form-field>
                        </div>
                        <div class="col-auto">
                          <button mat-icon-button matTooltip="Warn" color="warn" (click)="deletePostParam(index)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
  
                    </ng-container>
                  </mat-card-content>
              </mat-card>
            </div>
          </ng-container>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial (click)="closeTemplate()">
          Cancel
        </button>
        <button mat-raised-button color="primary" (click)="saveApiorEnityConfig()"
          [disabled]="apiDataSourceApiConfigForm.invalid">
          Save Config
        </button>
      </mat-dialog-actions>
    </ng-template>

    
    <ng-template #barOrLineCharConfig>
      <form [formGroup]="chartDetailsFormGroup">
        <ng-container [ngTemplateOutlet]="widgetId"></ng-container>
        <mat-divider></mat-divider>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" class="d-flex">
                <div class="panal-title">Chart Properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mat-form-field-container">
            <mat-accordion togglePosition="before" displayMode="flat">
              <mat-form-field class="w-100 rounded-0" appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" formControlName="title" />
              </mat-form-field>
              <mat-divider></mat-divider>

              <div class="pt-2">
                <mat-expansion-panel expanded="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">Data Source</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div class="mb-inner-pennal">
                      <mat-form-field class="w-100 m-1" appearance="outline">
                        <mat-label>Data Source Type</mat-label>
                        <mat-select formControlName="dataSourceType" disableRipple>
                          <mat-option *ngFor="let option of chartDataSourceTypes" [value]="option.value">
                            {{ option.label }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      <ng-container *ngIf="
                          chartDetailsFormGroup.value.dataSourceType == 'api'
                        ">
                      <div [formGroup]="selectedApiGroup">
                        <mat-form-field  class="w-100 m-1" appearance="outline">
                        <mat-label>Select Api</mat-label>
                        <mat-select formControlName="selectedApi" >
                          <mat-option *ngFor="let api of userApis" [value]="api.apiId">{{api.apiName}}</mat-option>
                        </mat-select>
                       </mat-form-field>
                      </div>

                        <!-- <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                            addOrEditDatSourceConfig(
                              'add',
                              apiDataSourceConfig
                            )
                          ">
                          Add or Edit API config
                        </button> -->
                        <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                            getApiOrEntityDefinitionBasedOnForm(
                              'api',
                              selectedApiGroup.get('selectedApi')?.value
                            )
                          ">
                          Get Api Definition
                        </button>
                      </ng-container>
                      <ng-container *ngIf="
                          chartDetailsFormGroup.value.dataSourceType ==
                          'entity'
                        ">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Entity</mat-label>
                          <mat-select formControlName="entity">
                            <mat-option *ngFor="
                                let option of listOfEntitiesOfMobAndWebApplication
                              " [value]="option.entity_id">
                              {{ option.entity_name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                            getApiOrEntityDefinitionBasedOnForm(
                              'entity',
                              chartDetailsFormGroup.get('entity')?.value
                            )
                          ">
                          Get Entity Definition
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <ng-container *ngIf="displayedContent === widgetTypes.barChart || displayedContent === widgetTypes.lineChart || displayedContent === widgetTypes.stackBarChart">
                <div class="pt-2">
                  <mat-expansion-panel expanded="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">X-Axis Properties</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div formGroupName="xAxisProperties" class="mb-inner-pennal">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Label</mat-label>
                          <input matInput formControlName="label" type="text" />
                        </mat-form-field>
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Categories</mat-label>
                          <mat-select formControlName="categories">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div class="pt-2">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Y-Axis Properties</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div formGroupName="yAxisProperties" class="mb-inner-pennal">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Label</mat-label>
                          <input matInput formControlName="label" type="text" />
                        </mat-form-field>
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Series</mat-label>
                          <mat-select multiple formControlName="series">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div formArrayName="individualSeriesProperties">
                          <ng-container *ngFor="
                              let item of individualSeriesProperties.controls;
                              let index = index
                            ">
                            <div [formGroupName]="index">
                              <mat-form-field class="w-100 rounded-0" appearance="outline">
                                <mat-label>Label</mat-label>
                                <input matInput formControlName="label" type="text" />
                              </mat-form-field>
                              <mat-form-field class="w-100 rounded-0" appearance="outline">
                                <mat-label>Key</mat-label>
                                <input matInput formControlName="key" [value]="item" type="text" />
                              </mat-form-field>
  
                              
                              <div class="color-item d-flex justify-content-between align-items-center">
                                <div class="content">
                                  <div class="label">Color</div>
                                </div>
                                <div mat-ripple class="color-thumb">
                                  <input type="color" formControlName="color" />
                                </div>
                              </div>
                            </div>
  
                          </ng-container>
                        </div>
                        <div class="app-name mb-3" *ngIf="displayedContent === widgetTypes.barChart || displayedContent === widgetTypes.stackBarChart">
                          <p class="title ellipsis-input">
                            Data Labels
                          </p>
                          <mat-slide-toggle formControlName="dataLabels"></mat-slide-toggle>
                        </div>
                        <div class="app-name mb-3" *ngIf="displayedContent === widgetTypes.stackBarChart">
                          <p class="title ellipsis-input">
                            Stack Labels
                          </p>
                          <mat-slide-toggle formControlName="stackLabels"></mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </ng-container>

              <ng-container *ngIf="displayedContent === widgetTypes.fixedBarChart">
                <div class="pt-2">
                  <mat-expansion-panel expanded="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">X-Axis Properties</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div formGroupName="xAxisProperties" class="mb-inner-pennal">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Label</mat-label>
                          <input matInput formControlName="label" type="text" />
                        </mat-form-field>
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Categories</mat-label>
                          <mat-select formControlName="categories">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div class="pt-2">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Y-Axis1 Properties</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div formGroupName="fixedChartYAxisProperties" class="mb-inner-pennal">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Label</mat-label>
                          <input matInput formControlName="label1" type="text" />
                        </mat-form-field>
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Series</mat-label>
                          <mat-select multiple formControlName="series1">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div formArrayName="yAxis1SeriesProperties">
                          <ng-container *ngFor="
                              let item of yAxis1SeriesProperties.controls;
                              let index = index
                            ">
                            <div [formGroupName]="index">
                              <mat-form-field class="w-100 rounded-0" appearance="outline">
                                <mat-label>Label</mat-label>
                                <input matInput formControlName="label" type="text" />
                              </mat-form-field>
                              <mat-form-field class="w-100 rounded-0" appearance="outline">
                                <mat-label>Key</mat-label>
                                <input matInput formControlName="key" [value]="item" type="text" />
                              </mat-form-field>
  
                              
                              <div class="color-item d-flex justify-content-between align-items-center">
                                <div class="content">
                                  <div class="label">Color</div>
                                </div>
                                <div mat-ripple class="color-thumb">
                                  <input type="color" formControlName="color" />
                                </div>
                              </div>
                            </div>
  
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div class="pt-2">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Y-Axis2 Properties</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div formGroupName="fixedChartYAxisProperties" class="mb-inner-pennal">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Label</mat-label>
                          <input matInput formControlName="label2" type="text" />
                        </mat-form-field>
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Series</mat-label>
                          <mat-select multiple formControlName="series2">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div formArrayName="yAxis2SeriesProperties">
                          <ng-container *ngFor="
                              let item of yAxis2SeriesProperties.controls;
                              let index = index
                            ">
                            <div [formGroupName]="index">
                              <mat-form-field class="w-100 rounded-0" appearance="outline">
                                <mat-label>Label</mat-label>
                                <input matInput formControlName="label" type="text" />
                              </mat-form-field>
                              <mat-form-field class="w-100 rounded-0" appearance="outline">
                                <mat-label>Key</mat-label>
                                <input matInput formControlName="key" [value]="item" type="text" />
                              </mat-form-field>
  
                              
                              <div class="color-item d-flex justify-content-between align-items-center">
                                <div class="content">
                                  <div class="label">Color</div>
                                </div>
                                <div mat-ripple class="color-thumb">
                                  <input type="color" formControlName="color" />
                                </div>
                              </div>
                            </div>
  
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </ng-container>




              <ng-container *ngIf="displayedContent === widgetTypes.pieChart || displayedContent === widgetTypes.donutChart">
                <div class="pt-2">
                  <mat-expansion-panel expanded="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div class="panal" class="d-flex">
                          <div class="panal-title">Data Properties</div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="d-flex flex-column gap-3">
                      <div formGroupName="xAxisProperties" class="mb-inner-pennal">
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Label</mat-label>
                          <mat-select formControlName="label">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w-100 rounded-0" appearance="outline">
                          <mat-label>Value</mat-label>
                          <mat-select formControlName="categories">
                            <mat-option *ngFor="let option of apikeys" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </div>
              </ng-container>
              <div class="pt-2">
                <mat-expansion-panel expanded="false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="panal" class="d-flex">
                        <div class="panal-title">Legend Properties</div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="d-flex flex-column gap-3">
                    <div formGroupName="legendPropertyies" class="mb-inner-pennal">
                      <div class="app-name mb-3">
                        <p class="title ellipsis-input" [matTooltip]="'item.widgetLabel'">
                          Display Legend
                        </p>
                        <mat-slide-toggle formControlName="displayLegend"></mat-slide-toggle>
                      </div>
                      <ng-container *ngIf="
                         chartDetailsFormGroup.get('legendPropertyies')
                          ?.value.displayLegend
                      ">
                      <mat-form-field class="w-100 m-1" appearance="outline">
                        <mat-label>Legend Align Position</mat-label>
                        <mat-select formControlName="legendAlignment" disableRipple>
                          <mat-option *ngFor="
                              let option of legendAlignmentOptions
                            " [value]="option.value" >
                            {{ option.key }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    </div>
                  </div>
                </mat-expansion-panel>
              </div>
              <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateDiplayWidgetValues()">
                Update component
              </button>
            </mat-accordion>
          </div>
        </mat-expansion-panel>
      </form>
    </ng-template>

    <ng-template #mapConfig>
      <form [formGroup]="mapFormGroup">
        <mat-form-field class="w-100 rounded-0">
          <mat-label>Key</mat-label>
          <input matInput type="text" formControlName="key" />
        </mat-form-field>
        <mat-divider></mat-divider>

        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="panal" class="d-flex">
                <div class="panal-title">Map Properties</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="mat-form-field-container">
            <mat-accordion togglePosition="before" displayMode="flat">
              <mat-form-field class="w-100 rounded-0" appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput type="text" formControlName="title" />
              </mat-form-field>
              <mat-form-field class="w-100 rounded-0" appearance="outline">
                <mat-label>Zoom</mat-label>
                <input matInput type="number" formControlName="zoom" />
                <mat-error class="error-message" *ngIf="mapFormGroup.get('zoom')?.hasError('min')">Should be greater than 0</mat-error>
              </mat-form-field>
              <mat-divider></mat-divider>
            <div class="pt-2">
              <mat-expansion-panel expanded="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="panal" class="d-flex">
                      <div class="panal-title">Data Source</div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex flex-column gap-3">
                  <div class="mb-inner-pennal">
                    <mat-form-field class="w-100 m-1" appearance="outline">
                      <mat-label>Data Source Type</mat-label>
                      <mat-select formControlName="dataSourceType" disableRipple>
                        <mat-option *ngFor="let option of mapDataSourceTypes" [value]="option.value">
                          {{ option.label }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="
                        mapFormGroup.value.dataSourceType == 'api'
                      ">
                      <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                          addOrEditDatSourceConfig(
                            'add',
                            apiDataSourceConfig
                          )
                        ">
                        Add or Edit API config
                      </button>
                      <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                          getApiOrEntityDefinitionBasedOnForm(
                            'api',
                            'apiDataSourceApiConfigForm'
                          )
                        ">
                        Get Api Definition
                      </button>
                    </ng-container>
                    <ng-container *ngIf="
                        mapFormGroup.value.dataSourceType ==
                        'entity'
                      ">
                      <mat-form-field class="w-100 rounded-0" appearance="outline">
                        <mat-label>Entity</mat-label>
                        <mat-select formControlName="entity">
                          <mat-option *ngFor="
                              let option of listOfEntitiesOfMobAndWebApplication
                            " [value]="option.entity_id">
                            {{ option.entity_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="
                          getApiOrEntityDefinitionBasedOnForm(
                            'entity',
                            'mapFormGroup'
                          )
                        ">
                        Get Entity Definition
                      </button>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <div class="pt-2">
              <mat-expansion-panel expanded="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="panal" class="d-flex">
                      <div class="panal-title">Popup Content Properties</div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex flex-column gap-3">
                  <div formGroupName="contentProps" class="mb-inner-pennal">
                    <mat-form-field class="w-100 m-1" appearance="outline">
                      <mat-label>Content to be shown</mat-label>
                      <mat-select formControlName="contentKeys" disableRipple multiple>
                        <mat-option *ngFor="let option of mapContentData" [value]="option">
                          {{ option }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            
          <div class="pt-2">
            <mat-expansion-panel expanded="false">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div class="panal" class="d-flex">
                    <div class="panal-title">Marker Properties</div>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column gap-3">
                <div formGroupName="markerProps" class="mb-inner-pennal">
                  <mat-form-field class="w-100 m-1" appearance="outline">
                    <mat-label>Marker Types</mat-label>
                    <mat-select formControlName="markerType" placeholder="Select Marker Type">
                      <mat-option *ngFor="let marker of markerTypes" [value]="marker.value">{{marker.key}}</mat-option>
                    </mat-select>
                    <mat-error class="error-message" *ngIf="mapFormGroup.get('markerProps.markerType')?.hasError('required')">Please select marker type</mat-error>
                  </mat-form-field>
            
                  <mat-form-field class="w-100 m-1" appearance="outline"*ngIf="mapFormGroup.get('markerProps.markerType')?.value !== 'circle'">
                    <mat-label>Size</mat-label>
                    <input matInput type="text" formControlName="size" />
                  </mat-form-field>
                  <mat-form-field class="w-100 m-1" appearance="outline" *ngIf="mapFormGroup.get('markerProps.markerType')?.value === 'circle'">
                    <mat-label>Radius</mat-label>
                    <input matInput type="number" formControlName="radius" />
                  </mat-form-field>
                  <mat-form-field class="w-100 m-1" appearance="outline">
                    <mat-label>Latitude Key</mat-label>
                    <mat-select formControlName="lat" disableRipple>
                      <mat-option *ngFor="let option of mapContentData" [value]="option">
                        {{ option }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="w-100 m-1" appearance="outline">
                    <mat-label>Longitude Key</mat-label>
                    <mat-select formControlName="lon" disableRipple>
                      <mat-option *ngFor="let option of mapContentData" [value]="option">
                        {{ option }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="theming-color-items">
                    <div class="color-item">
                      <div class="content">
                        <div class="label">Marker Color</div>
                        <div class="value">{{ mapFormGroup.get('markerProps.color')?.value }}</div>
                      </div>
                      <div [style.background-color]="mapFormGroup.get('markerProps.color')?.value" mat-ripple
                        class="color-thumb">
                        <input type="color" formControlName="color" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </mat-expansion-panel>
          </div>
      
            <button mat-stroked-button class="w-100 mt-3" color="primary" (click)="updateDiplayWidgetValues()">
                Update component
              </button>
            </mat-accordion>
          </div>
          </mat-expansion-panel>
      </form>
    </ng-template>

  </div>
</mat-accordion>

<ng-template #fontIconTemplate let-formGroup="formGroup">
  <div class="icon-container" [formGroup]="formGroup">
    <button class="fab-normal" mat-mini-fab 
      (click)="formGroup.get('bold')?.setValue(!formGroup.get('bold')?.value)" [ngClass]="{'active': formGroup.get('bold')?.value}">  
      <mat-icon>format_bold</mat-icon>
    </button>

    <button class="fab-normal" mat-mini-fab [class.active]="formGroup.get('italic')?.value" (click)="
        formGroup.get('italic')?.setValue(!formGroup.get('italic')?.value)
      ">
      <mat-icon>format_italic</mat-icon>
    </button>
    <button class="fab-normal" mat-mini-fab [class.active]="formGroup.get('underline')?.value" (click)="
        formGroup.get('underline')?.setValue(!formGroup.get('underline')?.value)
      ">
      <mat-icon>format_underlined</mat-icon>
    </button>
    <div class="item">
      <button mat-mini-fab class="fab-normal" (click)="
          formGroup?.get('fontSize')?.value > 0 &&
            formGroup
              .get('fontSize')
              ?.setValue(formGroup.get('fontSize')?.value - 1)
        ">
        <mat-icon>remove</mat-icon>
      </button>
      <input id="fontSizeInput" type="number" [formControl]="formGroup?.get('fontSize')" />
      <button mat-mini-fab class="fab-normal" (click)="
          formGroup
            .get('fontSize')
            ?.setValue(formGroup.get('fontSize')?.value + 1)
        ">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #AuthDataSource>
  <mat-dialog-content>
    <mat-stepper #stepper color="primary" linear>
      <mat-step label="Auth Api Details" [stepControl]="AuthApiGroup">
        <form [formGroup]="AuthApiGroup">
          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
            <mat-label>Auth API URL</mat-label>
            <input matInput formControlName="authApiUrl" />
            <mat-error *ngIf="showAuthUrlError">Please Enter a Valid Url</mat-error>
          </mat-form-field>

          <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
            <mat-label>Auth Type</mat-label>
            <mat-select formControlName="auth">
              <!-- <mat-option value="token">Token</mat-option> -->
              <mat-option value="user" (click)="authApiEmailCreds.reset()">Username & Password</mat-option>
              <mat-option value="email" (click)="authApiuserCreds.reset()">Email & Password</mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="AuthApiGroup.get('auth')?.value == 'user'">
            <form [formGroup]="authApiuserCreds">
              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>Username</mat-label>
                <input matInput formControlName="authUsername" />
              </mat-form-field>

              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="authPassword" />
              </mat-form-field>
            </form>
          </ng-container>

          <ng-container *ngIf="AuthApiGroup.get('auth')?.value == 'email'">
            <form [formGroup]="authApiEmailCreds">
              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="authEmail" />
              </mat-form-field>

              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>password</mat-label>
                <input matInput formControlName="authPassword" />
              </mat-form-field>
            </form>
          </ng-container>

          <ng-container *ngIf="AuthApiGroup.get('auth')?.value == 'key'">
            <form [formGroup]="authApiEmailCreds">
              <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
                <mat-label>password</mat-label>
                <input matInput formControlName="authPassword" />
              </mat-form-field>
            </form>
          </ng-container>
        </form>
      </mat-step>
      <mat-step label="Test Api">
        <h1 *ngIf="authApiStatus == 200 || authApiStatus == 201" style="color: rgb(37, 193, 37)">
          Check Successful with Status - {{ authApiStatus }}
        </h1>
        <h1 *ngIf="authApiStatus != 200 && authApiStatus != 201" style="color: rgb(240, 27, 27)">
          Check Failed !! status - {{ authApiStatus }}
        </h1>

        <div class="json-container">
          <p>Your URL</p>
          <p>{{ AuthApiGroup.get("authApiUrl")?.value }}</p>
        </div>

        <div class="json-container">
          {{ authResposeData | json }}
        </div>

        <ng-container *ngIf="authApiStatus == 200 || authApiStatus == 201">
          <form [formGroup]="AuthApiGroup">
            <mat-form-field class="w-100 mt-3 rounded-0" appearance="outline">
              <mat-label>Token</mat-label>
              <mat-select formControlName="apiKey">
                <ng-container *ngFor="let key of authApikeys">
                  <mat-option [value]="key">{{ key }}</mat-option>
                </ng-container>
              </mat-select>
              <mat-icon matSuffix
                matTooltip="Enter the key name you want to assign to the dropdown Ex: username, if your data consists of Userdetails"
                matTooltipPosition="after">info</mat-icon>
            </mat-form-field>
          </form>
        </ng-container>
      </mat-step>
    </mat-stepper>
  </mat-dialog-content>
  <mat-dialog-actions class="dailog-footer-buttons">
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial (click)="closeTemplate()">
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="next(stepper)" [disabled]="
        (AuthApiGroup.get('auth')?.value == 'user' &&
          !authApiuserCreds.valid) ||
        (AuthApiGroup.get('auth')?.value == 'email' && !authApiEmailCreds.valid)
      " *ngIf="stepper.selectedIndex == 0">
      Check API
    </button>
    <button mat-raised-button color="primary" (click)="next(stepper)" *ngIf="stepper.selectedIndex == 1"
      [disabled]="authApiStatus != 200 && authApiStatus != 201">
      Save
    </button>
  </mat-dialog-actions>
</ng-template>




<ng-template #widgetId>
  <mat-toolbar>
    <span class="fs-6">Widget Id</span>
    <div class="flex-fill"></div>
    <button mat-icon-button [matTooltip]="selectedWidgetMetaData.widgetId" (click)="copyToClipboard(selectedWidgetMetaData.widgetId)">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-toolbar>
</ng-template>